import { BudgetPreviewModal } from '@components/Budget/BudgetPreviewModal'
import { Toolbar } from '@components/Toolbar/export'
import { TexturesPanel } from '@components/Viewer3D/TexturesPanel'
import { SelectedUnitInfo } from '@components/Viewer3D/SelectedUnitInfo'
import { useAppStore } from '@store'
import { useState } from 'react'
import { CompactTopbar } from './CompactTopbar'
import { ModeBar } from './ModeBar'
import { ActiveSheetHost } from './SheetHost'
import { MoreActionsSheet, TouchActionBar } from './TouchActionBar'

/**
 * Chrome para tablet y móvil:
 * Canvas protagonista + mode bar + bottom sheets.
 * Desktop no usa este componente.
 *
 * Adaptación KUBE: solo sheets modules / textures / more
 * (sin options / ArmsCushionsPanel).
 *
 * Correspondencia: ATEMPORAL mobile-28-07-2026 (`47ee2081`).
 */
export function TouchChrome() {
  const currentObjectID = useAppStore.use.currentObjectID()
  const currentLayer = useAppStore.use.currentLayer()
  const layers = useAppStore.use.layers()
  const items = useAppStore.use.items()
  const selectedItems = layers[currentLayer]?.selected || new Set()
  const [showBudgetPreview, setShowBudgetPreview] = useState(false)

  return (
    <>
      <CompactTopbar />

      <div className='pointer-events-none fixed left-3 top-14 z-[65] max-w-[min(100%-6.5rem,280px)]'>
        <div className='pointer-events-auto'>
          <SelectedUnitInfo
            items={items}
            selectedItems={selectedItems}
            currentObjectID={currentObjectID}
          />
        </div>
      </div>

      <TouchActionBar onOpenBudget={() => setShowBudgetPreview(true)} />
      <ModeBar />

      <ActiveSheetHost>
        {(sheet) => {
          if (sheet === 'modules') return <Toolbar presentation='embedded' />
          if (sheet === 'textures') return <TexturesPanel presentation='embedded' />
          return <MoreActionsSheet onOpenBudget={() => setShowBudgetPreview(true)} />
        }}
      </ActiveSheetHost>

      <BudgetPreviewModal
        open={showBudgetPreview}
        onClose={() => setShowBudgetPreview(false)}
      />
    </>
  )
}
